import React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from "react-router-dom" 
import { addCarModel, getCarBrand, updateCarModel } from '../../../actions'
import { useEffect } from 'react'

const CarModelForm = () => {
    const [carModelform, setCarModelForm] = useState({
        name:'',
        nameAr:'',
        priority:'',
        brand:'',
        status: 'true'
    })
    const [dataEdit, setDataEdit] = useState(false)

    const dispatch = useDispatch()
    
    useEffect(() => {
        const getType = window.location.href?.split('/')?.[6]
        if(getType !== 'Add') setDataEdit(true)

		dispatch(getCarBrand())
    },[])

    const carBrandList = useSelector(state => state.home.CarBrandList)?.response

    useEffect(() => {
        const dataEditData = JSON.parse(localStorage.getItem('editCarModel-data'))
        if(dataEdit && Object.keys(dataEditData)?.length > 0){
            setCarModelForm({
                name: dataEditData?.name,
                nameAr: dataEditData?.nameAr,
                brand: dataEditData?.brandId,
                priority: dataEditData?.priority,
                status: dataEditData?.status ? 'true' : 'false',
            })
        }
    },[dataEdit])

    const onChangeHandle = e => {
        const { name, value} = e.target
        setCarModelForm({...carModelform, [name]:value})
    }

    const onSave = () => {
        if(!dataEdit){
            const payload = {
                name: carModelform?.name,
                nameAr: carModelform?.nameAr,
                brandId: carModelform?.brand,
                priority: Number(carModelform?.priority),
                status: carModelform?.status === 'true' ? true : false
            }
            dispatch(addCarModel(payload))
        } else {
            const payload = {
                carModelId: JSON.parse(localStorage.getItem('editCarModel-data'))?.carModelId,
                name: carModelform?.name,
                nameAr: carModelform?.nameAr,
                brandId: carModelform?.brand,
                priority: Number(carModelform?.priority),
                status: carModelform?.status === 'true' ? true : false
            }
            dispatch(updateCarModel(payload))
        }
        localStorage.removeItem('editCarModel-data')
    }



  return (
    <div className='main-body'>
      <div className='page-wrapper'>
        <div className='page-header'>
          <div className='row align-items-end'>
            <div className='col-lg-8'>
              <div className='page-header-title'>
                <div className='d-inline'>
                  <h4>{!dataEdit ? 'Add' : 'Update'} Car Model</h4>
                </div>
              </div>
            </div><div className='col-lg-4'>
                    <div className='page-header-breadcrumb'>
                      <ul className='breadcrumb-title'>
                        <li className='breadcrumb-item'>
                          <Link to='/'>
                            <i className='feather icon-home'></i>{' '}
                          </Link>
                        </li>
                        <li className='breadcrumb-item'>
                          <Link to='/CarDetail/CarModel'>Car Model</Link>
                        </li>
                        <li className='breadcrumb-item active'>{!dataEdit ? 'Add' : 'Update'} Car Model</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className='page-body'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <div className='card card-border-default'>
                      <div className='card-block'>
                        
                        <div className='tab-content tabs'>
                          <div
                            className='tab-pane  active'
                            id={'car_user_'}
                            role='tabpanel'
                            aria-labelledby=''>
                              <div className=''>


                                        <div className='card-body'>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group row'>
                                                        <label className='col-sm-3 col-form-label'>Car Model</label>
                                                        <div className='col-sm-9'>
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            name='name'
                                                            value={carModelform.name}
                                                            placeholder='Car Model Name'
                                                            onChange={onChangeHandle}
                                                        />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group row'>
                                                        <label className='col-sm-3 col-form-label'>Car Model Ar</label>
                                                        <div className='col-sm-9'>
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            name='nameAr'
                                                            value={carModelform.nameAr}
                                                            placeholder='Car Model Name Ar'
                                                            onChange={onChangeHandle}
                                                        />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group row'>
                                                        <label className='col-sm-3 col-form-label'>Priority</label>
                                                        <div className='col-sm-9'>
                                                        <input
                                                            type='number'
                                                            min={1}
                                                            max={2}
                                                            className='form-control'
                                                            name='priority'
                                                            value={carModelform.priority}
                                                            placeholder='Car Priority'
                                                            onChange={onChangeHandle}
                                                        />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group row'>
                                                        <label className='col-sm-3 col-form-label'>Car Brand</label>
                                                        <div className='col-sm-9'>
                                                        <select
                                                            name='brand'
                                                            className='form-control'
                                                            onChange={onChangeHandle}
                                                            value={carModelform?.brand}
                                                            >
                                                                <option value="">Select Car Brand</option>
                                                                {
                                                                    carBrandList?.map((brand, index) => <option key={index} value={brand?.brandId}>{brand?.name}</option>)
                                                                }
                                                        </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group row'>
                                                        <label className='col-sm-3 col-form-label'>Status</label>
                                                        <div className='col-sm-9'>
                                                        <select
                                                            name='status'
                                                            className='form-control'
                                                            onChange={onChangeHandle}
                                                            value={carModelform?.status}
                                                            >
                                                            <option value={true} name='active'> 
                                                            Active
                                                            </option>
                                                            <option value={false} name='inactive'> 
                                                            Inactive
                                                            </option>
                                                        </select>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className='card-footer'>
                                                <div className='row float-right p-3'>
                                                    <button
                                                    onClick={onSave}
                                                    className='btn btn-grd-disabled mr-2'>
                                                    <i className='icofont icofont-save'></i>{dataEdit ? 'Update' : 'Add'}
                                                    </button>
                                                    <Link to={'/CarDetail/CarModel'} className='btn btn-outline-dark'>
                                                    {' '}
                                                    Cancel{' '}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default CarModelForm